import { actions } from "@grandvisionhq/state";
const idPayload = actions.payload();
const startConfigurator = actions.action(
  "configurator/start",
  actions.payload()
);
const isStartConfiguratorWithId = (id) => (a) => actions.isType(a, startConfigurator) && a.payload.id === id;
const nextStep = actions.action("configurator/next-step", idPayload);
const isNextStepWithId = (id) => (a) => actions.isType(a, nextStep) && a.payload.id === id;
const nextStepSuccess = actions.action(
  "configurator/next-step-success",
  actions.payload()
);
const isNextStepSuccessWithId = (id) => (a) => actions.isType(a, nextStepSuccess) && a.payload.id === id;
const nextStepFailed = actions.action(
  "configurator/next-step-failed",
  actions.payload()
);
const isNextStepFailedWithId = (id) => (a) => actions.isType(a, nextStepFailed) && a.payload.id === id;
const previousStep = actions.action("configurator/previous-step", idPayload);
const isPreviousStepWithId = (id) => (a) => actions.isType(a, previousStep) && a.payload.id === id;
const previousStepFailed = actions.action(
  "configurator/previous-step-failed",
  actions.payload()
);
const isPreviousStepFailedWithId = (id) => (a) => actions.isType(a, previousStepFailed) && a.payload.id === id;
const previousStepSuccess = actions.action(
  "configurator/previous-step-success",
  actions.payload()
);
const isPreviousStepSuccessWithId = (id) => (a) => actions.isType(a, previousStepSuccess) && a.payload.id === id;
const toggleFooter = actions.action("configurator/footer/toggle", idPayload);
const isToggleFooterWithId = (id) => (a) => actions.isType(a, toggleFooter) && a.payload.id === id;
const openFooter = actions.action("configurator/footer/open", idPayload);
const isOpenFooterWithId = (id) => (a) => actions.isType(a, openFooter) && a.payload.id === id;
const closeFooter = actions.action("configurator/footer/close", idPayload);
const isCloseFooterWithId = (id) => (a) => actions.isType(a, closeFooter) && a.payload.id === id;
const stepShown = actions.action(
  "configurator/step-shown",
  actions.payload()
);
const isStepShownWithId = (id) => (a) => actions.isType(a, stepShown) && a.payload.id === id;
const resetStepVisited = actions.action(
  "configurator/reset-step-visited",
  actions.payload()
);
const finish = actions.action(
  "configurator/finish",
  actions.payload()
);
const isFinishWithId = (id) => (a) => actions.isType(a, finish) && a.payload.id === id;
const finishFailed = actions.action(
  "configurator/finish-failed",
  actions.payload()
);
const finishSuccess = actions.action(
  "configurator/finish-success",
  actions.payload()
);
export {
  closeFooter,
  finish,
  finishFailed,
  finishSuccess,
  isCloseFooterWithId,
  isFinishWithId,
  isNextStepFailedWithId,
  isNextStepSuccessWithId,
  isNextStepWithId,
  isOpenFooterWithId,
  isPreviousStepFailedWithId,
  isPreviousStepSuccessWithId,
  isPreviousStepWithId,
  isStartConfiguratorWithId,
  isStepShownWithId,
  isToggleFooterWithId,
  nextStep,
  nextStepFailed,
  nextStepSuccess,
  openFooter,
  previousStep,
  previousStepFailed,
  previousStepSuccess,
  resetStepVisited,
  startConfigurator,
  stepShown,
  toggleFooter
};
//# sourceMappingURL=actions.js.map
